/* eslint-disable react/react-in-jsx-scope*/
export const JSON_URL = './totalmarket.json';
// export const JSON_URL = 'http://localhost:8000/';

export const YAHOO_BASE_URL = 'https://finance.yahoo.com/quote/';
export const HEADERS = ['Entity Name', 'Ticker Symbol', <abbr key="cusip">CUSIP</abbr>];